import Portfolioinfo from "../../../jsx/components/Dashboard/portfolioinfo/portfolioinfo";

const PortfolioInfoWrapper = () => {
  return <Portfolioinfo />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.admin,
  _enum.ROUTE_PERSONAS.collections,
];
export default constore(PortfolioInfoWrapper);
